export default __webpack_public_path__ + "static/media/mcqueen.fe80ab47.png";